import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { PhxModalBaseComponent } from './phx-modal-base.component';
import { PhxModalSize } from './phx-modal.types';
import { PHX_SIZE } from '../../constants';

@Component({
  selector: 'phx-modal-confirm',
  templateUrl: './phx-modal-confirm.component.html',
  styleUrls: ['./phx-modal-confirm.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '(keydown)': 'onKeydown($event)' },
})
export class PhxModalConfirmComponent extends PhxModalBaseComponent {
  @Input() phxSize: PhxModalSize = PHX_SIZE.XS;
  constructor() {
    super();
  }
}
